import script from "./CustomDropdownButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomDropdownButton.vue?vue&type=script&setup=true&lang=ts"

import "./CustomDropdownButton.vue?vue&type=style&index=0&id=b4b36554&scoped=true&lang=scss"

import exportComponent from "/builds/boikovky/pro2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4b36554"]])

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QList,QItem,QItemSection,QIcon,QItemLabel});qInstall(script, 'directives', {ClosePopup});
